export default __webpack_public_path__ + "static/glorybeth becker-436be120d5d35236c181fec51adae919.png";